module.exports = __webpack_public_path__ + "media/media/icons/next-icon-1c11dcefd78e3150a9bec6fb3e2ee8f3.png";